/**
 * Renders its children only while the server's chat feature flag is on
 * (`me.chatEnabled`, from /api/me `features.chat` — TICKVIEW_CHAT_ENABLED).
 * With chat off nothing inside mounts, so nothing inside fetches /api/chat/*.
 */
import type { ReactNode } from "react";
import { useAppSelector } from "@/state/hooks";

export function ChatOnly({ children }: { children: ReactNode }) {
  const chatEnabled = useAppSelector((s) => s.me.chatEnabled);
  return chatEnabled ? <>{children}</> : null;
}
